<app-access-item [avatarUser]="member().user" [hideOverflow]="true">
  <app-access-item-header>
    <span
      >{{ member().user.first_name }} {{ member().user.last_name }}
      @if (isMe()) {
        (You)
      }
    </span>
    @if (!isMemberTeamMember()) {
      <app-badge icon="/assets/icons/16/guest.svg" color="grey-50">Guest</app-badge>
    }
  </app-access-item-header>
  <app-access-item-body> {{ member().user.email }} </app-access-item-body>
  <app-access-item-cta>
    <app-gallery-share-context
      itemCta
      [currentAccessLevel]="memberAccess()"
      [accessLevels]="memberAccessLevels()"
      [mode]="'member'"
      (onChange)="changeMemberAccessLevel($event)"
      [disabled]="!galleryPermissions().can_edit && !isMe()"
      [type]="'gallery'"
    ></app-gallery-share-context>
  </app-access-item-cta>
</app-access-item>
